import type { TabType } from "Shared/Components/Tabs/Types/TabType";
import { TabPanel } from "@mui/lab";

export const getTabPanelElement = (
	tab: TabType,
	...args
): React.JSX.Element => {
	return (
		<TabPanel value={tab.index} sx={{ px: 0 }}>
			{typeof tab.tab === "function" ? tab.tab(...args) : tab.tab}
		</TabPanel>
	);
};
